<template>
  <div class=" is-fullwidth">
    
   

    <div class="is-pulled-right">
        <select class="input" v-model="limit" style="display:none">
        <option value="">Number of Orders</option>
        <option value="10">10 orders</option>  
        <option value="50">50 orders</option>  
        <option value="100">100 orders</option>  
        <option value="250">250 orders</option>  
        <option value="">Display All Orders</option>  
      </select>
      <button @click="exportXLS()" class="button is-info ml-2 " >Export</button>
    </div>
    <div class="is-pulled-right "><input class="input" v-model="search" placeholder="search orders ..."/></div>
    <div class="is-pulled-right mr-4">
      <button class="button" :class="{'is-link':this.range_id == ''}" :disabled="this.loading==true" @click="setRangeId('')">ALL</button>
      <button class="button" :class="{'is-link':this.range_id == 1}" :disabled="this.loading==true" @click="setRangeId(1)">Jerseys</button>
      <button class="button" :class="{'is-link':this.range_id == 3}" :disabled="this.loading==true" @click="setRangeId(3)">Shorts</button>
      <button class="button" :class="{'is-link':this.range_id == 2}" :disabled="this.loading==true" @click="setRangeId(2)">LW</button>
    </div> 
     <div class="is-pulled-right mr-4 select">
      <select class="input" v-model="show_week" >
         <option value="">Display All Weeks</option>  
        <option  v-for="row in planner_weeks" :key="row.id" :value="row.date">{{ row.date_formatted}}</option>  
       
      </select>
    </div>
     
    <div class="buttons">
      <button class=" button  is-light mr-4" @click="sidebarVisible = !sidebarVisible">Toggle Menu</button>
          <button class="button " :disabled="loading==true" v-bind:class="{'is-success': selected_location_id == row.id}" v-for="row in locations" :key="row.id" @click="selected_location_id = row.id">{{ row.name }}</button>
        
          <button class="button is-light">{{ filteredOrders.length }} orders</button>
        <button class="button is-light">{{ this.total_garments }} garments</button>
      </div>

      <div v-if="loading === true">
                <div class="notification is-info">Loading orders ...</div>
      </div>
   
    
    
    <table class="table  is-fullwidth is-size-7 is-striped" id="orderstable" v-if="loading==false">
    	<thead>
    		<th width="60">&nbsp;</th>
        <th>PO Number</th>
   	 		<th>Customer</th>
          <th @click="updateSortOrder('orderdate')" style="cursor:pointer;">Order Date
            <span v-if="order_by === 'orderdate DESC'">&#8595;</span>
            <span v-if="order_by === 'orderdate ASC'">&#8593;</span>
          </th>
          <th @click="updateSortOrder('deliverydate')" style="cursor:pointer">Delivery
            <span v-if="order_by === 'deliverydate DESC'">&#8595;</span>
            <span v-if="order_by === 'deliverydate ASC'">&#8593;</span>
          </th>
          <th>Garment</th>
          <th>Fabric</th>
          <th>Type</th>
          <th>Qty</th>
          <th>Art</th>
          <th>Paper</th>
          <th>Rolls</th>
          <th>Cutting</th>
          <th>&nbsp;</th>
          <th>Week</th>
          <th>&nbsp;</th>
          <th>Notes</th>
    	</thead>
    	<tbody>
        
            <tr v-if="loading == false && filteredOrders.length == 0">
                <td colspan="7" ><div class="notification is-warning">There are no orders to show</div></td>
            </tr>
        <template v-for="row in filtered_planner_weeks" >
            <tr  :key="row.date" class="is-selected">
              <th colspan="17">Week Commencing {{ row.date_formatted }} - {{ numberOrders(row.date)}} orders / {{ numberGarments(row.date)}} garments</th>
            </tr>
            <tr v-for="order in orderedOrders[row.date]" :key="order.id" :class="{'has-background-danger has-text-white' : order.printing_urgent == 1}">
              <td >
                  <a :href="ASP_URL + '/printorder.asp?txtPONumber=' + order.ponumber" target="_blank"><button class="button is-small is-info" :disabled="working===true" >Print</button></a>
              </td>
               <td ><router-link :to="'/printing-cutting/view-order/' + order.ponumber" target="_blank">{{order.ponumber}}</router-link></td>
          <td>{{order.clientname}}</td>
           <td >{{order.orderdate}}</td>
          <td>{{order.deliverydate}}</td>
          <td>{{order.garmentname}}<br />
          {{ order.designname }}</td>
          <td>{{order.fabric_name}}</td>
          <td>
            <span v-if="order.fully_printed==1">F/P</span>
              <span v-if="order.part_printed==1">P/P</span>
                <span v-if="order.cut_sew==1">C/S</span>

          </td>
          <td>{{ order.total_qty }}</td>
          <td>
              <span class="icon has-text-success" v-if="order.artwork_completed == 1">
                <i class="fa fa-check"></i>
            </span>
            <span class="icon has-text-warning" v-else-if="order.artwork_finished == 1">
                <i class="fa fa-check"></i>
            </span>
          </td>
          <td>
              <span class="icon has-text-success" v-if="order.artwork_printed_paper == 1">
                <i class="fa fa-check"></i>
            </span>
          </td>
          <td>
            <span class="icon has-text-success" v-if="order.artwork_printed_rolls == 1">
                <i class="fa fa-check"></i>
            </span>
            <span class="icon has-text-warning" v-if="order.artwork_printed_rolls == 0">
                <a :href="'/printing-cutting/data-input?area=paper&ponumber=' + order.ponumber" target="_blank"><i class="fa fa-question"></i></a>
            </span>

          </td>
          <td>
            <span class="icon has-text-success" v-if="order.digital_print_cutting == 1">
                <i class="fa fa-check"></i>
            </span>
            <span class="" v-if="order.digital_print_cutting == 0">
                <span v-if="order.part_printed == 1">
                  <select class="select"   @change="updateCuttingType(order)" v-model="order.cutting_type_multi" :disabled="working==true">
                    <option value="0">Single</option>
                    <option value="1" >Multi</option>
                    
                  </select>
                </span>
                <span v-else class="icon has-text-warning">
                  <a :href="'/printing-cutting/data-input?area=cutting&ponumber=' + order.ponumber" target="_blank" ><i class="fa fa-question"></i></a>
                </span>
            </span>

          </td>
          <td>
            <router-link :to="'/printing-cutting/bundling/' + order.orderID" v-if="order.print_location_id != 2">
                <span class="icon" :class="{ 'has-text-success': order.bundles_created == 1, 'has-text-danger': order.bundles_created == 0}">
                 <i class="fa fa-barcode">&nbsp;</i>
               </span>
               </router-link>

          </td>
              <td>
                <select class="select" required v-model="order.printing_planner_date" @change="updatePlannerWeek(order)" :disabled="working==true">
                  <option value="">Select Week</option>
                  <option v-for="(week, index2) in planner_weeks" :key="index2" :value="week.date">{{  week.date_formatted }}</option>
                </select>
            </td>
            <td><label class="checkbox" style=""><input type="checkbox" :value="order.orderID" v-model="selectedOrderIDs"/></label></td>
            <td><button style="" class="button is-small is-light" @click="showNotesModal(order)" :class="{'is-warning' : order.print_planner_notes != null}">Notes</button></td>
            </tr>
        </template>

		   
            
           
    	</tbody>
    </table>


    <table class="table is-hoverable is-fullwidth" id="orderstableexcel" style="display:none">
    	<thead>
        <tr>
    		<th>PO Number</th>
   	 		<th>Customer</th>
          <th  >Order Date
            
          </th>
          <th >Delivery
           
          </th>
          <th>Garment</th>
          <th>Design</th>

          <th>Fabric</th>
          <th>Type</th>
          <th>Qty</th>
          <th>Artwork</th>
          <th>Paper</th>
          <th>Rolls</th>
          <th>Cutting</th>
          <th>Week</th>
            <th>Notes</th>
        </tr>
    	</thead>
    	<tbody>
		    
        <template v-for="row in planner_weeks">
            <tr  :key="row.date" class="is-selected">
              <th colspan="16">Week Commencing {{ row.date_formatted }} - {{ numberOrders(row.date)}} orders / {{ numberGarments(row.date)}} garments</th>
            </tr>
            <tr v-for="order in orderedOrders[row.date]" :key="'xls' + order.orderID" >
            
           
         
               <td >{{order.ponumber}}</td>
          <td>{{order.clientname}}</td>
           <td >{{order.orderdate_raw}}</td>
          <td>{{order.deliverydate_raw}}</td>
          <td>{{order.garmentname}}</td>
          <td>{{order.designname}}</td>
          <td>{{order.fabric_name}}</td>
          <td>
            <span v-if="order.fully_printed==1">F/P</span>
              <span v-if="order.part_printed==1">P/P</span>
                <span v-if="order.cut_sew==1">C/S</span>

          </td>
          <td>{{ order.total_qty }}</td>
          <td>
            <span class="" v-if="order.artwork_completed == 1">
                Complete
            </span>
            <span class="" v-else-if="order.artwork_finished == 1">
                Finished
            </span>
          </td>
          <td>
              <span  v-if="order.artwork_printed_paper == 1">
                Yes
            </span>
          </td>
          
          <td>
            <span  v-if="order.artwork_printed_rolls == 1">
                Yes
            </span>
            

          </td>
          <td>
<span  v-if="order.digital_print_cutting == 1">
                Yes
            </span>
            

          </td>
          <td>{{  order.printing_planner_date }}</td>
          <td><span v-if="order.print_planner_notes != null">{{ order.print_planner_notes.notes }}</span></td>
             
			</tr>
      </template>
    	</tbody>
    </table>
    
    <button @click="exportXLS()" style="" class="button is-info" v-if="loading==false">Export to Excel</button>
    
    <div id="modal-ter" class="modal " :class="{'is-active': showModal}" >
      
      <div class="modal-background"></div>
        <div class="modal-card" style="width:900px">
          <header class="modal-card-head">
            <p class="modal-card-title">Update Order Notes - {{  selectedPONumber }} </p>
            <button class="delete" aria-label="close" @click="showModal=false"></button>
          </header>
          <section class="modal-card-body">
            <form @submit.prevent="updateNotes()">
            <div class="field">
            <textarea class="textarea" placeholder="Enter notes here ..." v-model="selectedNotes"></textarea>
          </div>
            <div class="field ">
              <div class="control">
                <button class="button is-success" :disabled="working==true">Save</button>
              </div>
              
            </div>
            </form>
            
          </section>
          </div>
          
        </div>

  </div>

  
</template>

<script>
import OrderService from '@/services/OrderService.js';
import UtilityService from '@/services/UtilityService.js';
import OrderMixin from "@/mixins/OrderMixin.js";
import XLSX from 'xlsx';


export default {
  components: {
   	
  },
  mixins: [OrderMixin],
  data() {
    return {
       errors: [],
      orders: [],
      showModal: false,
      selectedOrderID: 0,
      working :false,
      loading: true,
      ASP_URL : process.env.VUE_APP_ASP_URL,
      locations: [],
      order_by: 'printing_urgent DESC,printing_planner_date ASC,deliverydate ASC',
      search: '',
      selected_location_id:0,
      limit: '',
      accessToken: '',
      start_date: '',
      planner_weeks: [],
      range_id: '',
      selectedNotes: '',
      selectedPONumber: '',
      selectedOrder: [],
      selectedOrderIDs: [],
      show_week: ''
      
    }
  },
   methods: {
   
    showNotesModal(order)
      {
        if( order.print_planner_notes != null)
        {
            this.selectedNotes = order.print_planner_notes.notes
        }
        else {
          this.selectedNotes = ''
        }
        this.selectedPONumber = order.ponumber
        this.selectedOrder = order
        this.showModal = true
    },
    updateNotes()
    {
      this.working = true

        var formdata = { 
             order_id: this.selectedOrder.orderID,
             notes : this.selectedNotes
        }; 

        OrderService.updatePrintPlannerNotes(this.accessToken, formdata)
        .then(() => {
            if(this.selectedOrder.print_planner_notes == null)
            {
              this.selectedOrder.print_planner_notes = []
              this.selectedOrder.print_planner_notes.notes = this.selectedNotes
            } 
            else { 
              this.selectedOrder.print_planner_notes.notes = this.selectedNotes
            }
           
            this.working = false
            this.showModal = false
            //console.log(response)
        }).catch((error) => {
           alert("Something went wrong and the order has not been updated. Please reload and try again")
            console.log("Error:" + JSON.stringify(error));
            this.working = false
        });
    },
    numberOrders(dateToCheck) {
      return this.isObjectAvailable(dateToCheck) ? Object.keys(this.orderedOrders[dateToCheck]).length : 0;
    },
    numberGarments(dateToCheck) {
      if(this.isObjectAvailable(dateToCheck))
      {
        return this.orderedOrders[dateToCheck].reduce((total, order) => total + order.total_qty, 0);
      }
      else {
        return 0
      }
    },
    isObjectAvailable(dateToCheck) {
      return this.orderedOrders[dateToCheck] && Object.keys(this.orderedOrders[dateToCheck]).length > 0;
    },
    setRangeId(newValue) {
      this.range_id = newValue
      //this.getOrders();
    },
      async getOrders() {
        if(this.selected_location_id > 0 && this.accessToken != '')
        {
          this.loading=true
          this.selectedOrderIDs = []
          this.orders = []
          OrderService.getPrintingCuttingOrders(this.accessToken, this.selected_location_id, this.limit, this.order_by, this.start_date, this.range_id, 0)
          .then(
            (orders => {
              this.$set(this, "orders", orders);
              this.loading=false
            }).bind(this)
          );
        }
        else{
          this.orders = []
          this.loading = false
        }
      },
    
    async processOrder(order) {
        this.working = true

        var order_id = order.orderID

        var formdata = { 
            _method: 'patch',
             artwork_printed_paper: 1
        }; 

        OrderService.updateOrder(this.accessToken, order_id, formdata)
        .then(() => {
            order.artwork_printed_paper = 1
            this.working = false
            //console.log(response)
        }).catch((error) => {
           alert("Something went wrong and the order has not been updated. Please reload and try again")
            console.log("Error:" + JSON.stringify(error.response.data));
            this.working = false
        });
    },
    async updatePlannerWeek(order) {
        this.working = true

        // Check if it's a multi-move
        if(this.selectedOrderIDs.length > 0)
        {
          if(confirm("Are you sure you want to update all selected orders ?"))
            {
              var formdata1 = { 
                  _method: 'patch',
                  field_to_set: 'printing_planner_date',
                  value: order.printing_planner_date,
                  order_ids: this.selectedOrderIDs //JSON.stringify()
              }; 

              OrderService.updateMultiOrder(this.accessToken, formdata1)
              .then(() => {
                  
                  this.working = false
                  this.getOrders();
                  // Remove the orders from this screen
              }).catch((error) => {
                alert("Something went wrong and the order has not been updated. Please reload and try again")
                  console.log("Error:" + JSON.stringify(error.response.data));
                  this.working = false
              });
          }
          else {
            this.working = false
          }
        }
        else {

          var order_id = order.orderID

          var formdata = { 
              _method: 'patch',
              printing_planner_date: order.printing_planner_date
          }; 

          OrderService.updateOrder(this.accessToken, order_id, formdata)
          .then(() => {
              this.working = false
              //console.log(response)
          }).catch((error) => {
            alert("Something went wrong and the order has not been updated. Please reload and try again")
              console.log("Error:" + JSON.stringify(error.response.data));
              this.working = false
          });
        }
    },
    async updateCuttingType(order) {
        this.working = true

          var order_id = order.orderID

          var formdata = { 
              _method: 'patch',
              cutting_type_multi: order.cutting_type_multi
          }; 

          OrderService.updateOrder(this.accessToken, order_id, formdata)
          .then(() => {
              this.working = false
              //console.log(response)
          }).catch((error) => {
            alert("Something went wrong and the order has not been updated. Please reload and try again")
              console.log("Error:" + JSON.stringify(error.response.data));
              this.working = false
          });
        
    },
    
    async getLocations() {
        UtilityService.getSimpleApiData(this.accessToken, "locations?printing=1&restrict_by_user=1").then(
               response => this.locations = response 
            );
      },
      async getPlannerWeeks() {
        if(this.accessToken != "")
        {
          UtilityService.getSimpleApiData(this.accessToken, "planner_weeks?printing=1&location_id=" + this.selected_location_id).then(
                response => this.planner_weeks = response 
              );
        }
      },
      exportXLS() {
      
      var wb = XLSX.utils.table_to_book(document.getElementById('orderstableexcel'), {sheet:"Sheet 1"});
      XLSX.writeFile(wb, 'Print Planner.xlsx')

    },
    
  },
  computed : {
      filteredOrders: function () {
       
        let filteredOrders =  this.orders.filter(function(row) {
            //if(  u.artwork_printed_paper == 0) 
           // {
               console.log(row)
              return 1
           // }
          })

          if(this.search != '' && this.search != null)
          {
            filteredOrders = filteredOrders.filter(row => row.ponumber.toLowerCase().includes(this.search.toLowerCase()))
          }

          return filteredOrders
       
     },
     filtered_planner_weeks: function() {
      let show_week = this.show_week;

        if(show_week != '')
        {
           return this.planner_weeks.filter(function(u) {
            return u.date == show_week;
          });
        }
        else {
            return this.planner_weeks
        }
        
     },
     total_garments: function () {
        return this.filteredOrders.reduce((total, order) => total + order.total_qty, 0);
     },
     orderedOrders() {
        // Use reduce to organize orders by date
        const organizedOrders =  this.filteredOrders.reduce((result, order) => {
          const date = order.printing_planner_date;
          if (!result[date]) {
            result[date] = [];
          }
          result[date].push(order);
          return result;
        }, {});

        return organizedOrders
      }
  },

  // Fetches posts when the component is created.
  created() {
     this.getAccessToken()
        .then(() => { 
           this.getOrders();
           this.getLocations();
           this.getPlannerWeeks();
        });
  },
 
  mounted() {
    

    if (localStorage.printing_location_id) {
      this.selected_location_id = localStorage.printing_location_id;
    }
    else{
      this.selected_location_id = ""
    }

    if (localStorage.print_planner_range_id) {
      this.range_id = localStorage.print_planner_range_id;
    }
    else{
      this.range_id = ""
    }

    
  },
   watch: {
    'selected_location_id'() {
      this.orders = []
      localStorage.printing_location_id = this.selected_location_id
      this.getPlannerWeeks();
      this.getOrders();
    },
    'range_id'() {
      localStorage.print_planner_range_id = this.range_id
      this.getPlannerWeeks();
      this.getOrders();
    },
   
  }
}


</script>

<script setup>
import { inject } from 'vue'

const sidebarVisible = inject('sidebarVisible')

if (!sidebarVisible) {
  console.warn('sidebarVisible not injected!')
}


</script>

